<script lang="ts" module>
  import CtaButton from '@/ui/elements/buttons/CTAButton.svelte';
  import BaseCard from '@/ui/elements/card/BaseCard.svelte';
  import ContentCard from '@/ui/elements/card/ContentCard.svelte';
  import Pagination from '@/ui/elements/pagination/Pagination.svelte';
  import { useReactiveState } from '@/utils/reactive-store/svelte';
  import { useActiveText } from '@/utils/teo-context';

  import TaskMaster from '../Performance/InitCard/cmps/TaskMaster.svelte';
</script>

<script lang="ts">
  let activeText = useActiveText();
  let generatorUI = activeText.current.generatorUi.withInit();
  let S = useReactiveState(generatorUI.state);

  // arrays sind noch nicht optimal unterstützt, functioniert besser mit () => ...
  // aber `$S.editingHistory` is einfacher
  // let editingHistory = useReactiveStore(() => $S.editingHistory);

  // für bind:value muss der store writable sein: hier z.B. mit lens 'instructions'
  // es geht aber auch bind:value={$S.currentHistory.instructions}
  let instructions = useReactiveState(() => $S.currentHistory, 'instructions');

  async function createText() {
    generatorUI.generateText();
  }
</script>

<div class="flex flex-col space-y-4">
  <ContentCard cardLabel="Deine Aufgabe:">
    <TaskMaster taskLabel="Konfiguriere deinen Text" done={$S.allSelected}></TaskMaster>
    <TaskMaster taskLabel="Gib ein Inhalts-Briefing ein" done={$instructions.length > 0}
    ></TaskMaster>
  </ContentCard>
  <BaseCard class="relative">
    <div class="mt-2">
      <!-- {#if isReply}
        <textarea
          id="context-textarea"
          bind:value={replyContext}
          class="w-full rounded-md border border-c-divider p-1"
          rows={3}
          placeholder="Gib hier optionalen Kontext für das Antwortschreiben ein..."
        ></textarea>
      {/if} -->
    </div>

    <form
      onsubmit={(event) => {
        event.preventDefault();
        createText();
      }}
      class="space-y-4"
    >
      <div>
        <div class="flex justify-between">
          <label class="mb-1 block font-bold" for="instructions-textarea">Anlass und Inhalt</label>
          {#if $S.editingHistory.length > 1}
            <Pagination
              pages={$S.editingHistory.length}
              current={$S.selectedHistory}
              onPageChange={(page) => generatorUI.changeSelectedHistory(page)}
            ></Pagination>
          {/if}
        </div>

        <textarea
          id="instructions-textarea"
          bind:value={$instructions}
          class="w-full rounded-md border border-c-divider p-1"
          rows={6}
          placeholder="Beschreibe hier kurz Anlass und Inhalt für deinen Text..."
        ></textarea>
      </div>
      <div class="flex gap-2">
        <CtaButton
          class="w-full"
          loading={$S.loading}
          variant="primary"
          disabled={$instructions.length === 0 || !$S.allSelected}
          icon="MagicButton"
          type="submit"
        >
          Neuen Text generieren...
        </CtaButton>
      </div>
    </form>
  </BaseCard>
</div>
